import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { _route, _stat } from "@/utils/constant";
// import Index from "@/containers/index/loadable";
import Hotel from "@/containers/hotel/loadable";
import About from "@/containers/about/loadable";
import App from "@/containers/app/loadable";
import {
  Message,
  TrendAudit,
  Menu,
  Catering,
  Psychology,
  Walking,
  Wish,
  CreativeCenter,
  Points,
  News,
  Care,
  Association,
  Mine,
  Memory,
  LuckyWheel,
  Address,
  Vote,
  ChangAn,
} from "./modules/loadable";
import Service from "@/containers/service/loadable";
import Empower from "@/containers/empower/loadable";
import EmpowerBookHouse from "@/containers/empower/book-house-loadable";
import Market from "@/containers/market/loadable";
import Pdf from "@/containers/pdf/loadable";
import NotFound from "@/containers/error-page/404";
import Login from "@/containers/login";
import AliCaptcha from "@/containers/login/ali-captcha";
import { Dialog } from "antd-mobile";
import Badge from "@/containers/badge/loadable";
import Doc from "@/containers/doc/loadable";
import Article from "@/containers/article/loadable";
import ArticleTransfer from "@/containers/article/transfer-loadable";
import MessageTrend from "@/containers/message/trend-loadable";
import MessageTrendAudit from "@/containers/message/trend-audit-loadable";
import TrendDetail from "@/containers/trend/detail";
import MailBox from "@/containers/mailbox";
import Flow from "@/containers/flow/loadable";
import { importScript, isSdicHomeApp } from "@/utils/utils";
import Live from "@/containers/live/loadable";
import RecreatActivity from "@/containers/recreat-activity";
import HardshipAid from "@/containers/hardship-aid";
import Activity from "@/containers/activity/loadable";
import ActivityCertificate from "@/containers/activity-certificate/loadable";
import Postbox from "@/containers/postbox/loadable";
import SupplierCollection from "@/containers/supplierCollection/loadable";
import JdInternalRedirect from "@/containers/jd-internal-redirect/loadable";
import AuthRoute from "./auth";
import FileReview from "@/containers/news/file-review";
import { useAppStore } from "@/store/appStore";
import sdicHomeEmit from "@/utils/prototal";

export default function Router() {
  const location = useLocation();
  useEffect(() => {
    /**
     * 路由切换时，关闭当前页面所有弹窗
     * @see https://ant-design-mobile.antgroup.com/zh/components/dialog#dialogclear
     */
    Dialog.clear();

    /**
     * 订餐页最外层禁止滚动
     * https://pms.stac.fun/index.php?m=bug&f=view&bugID=15329
     */
    if (location.pathname === _route.CATERING) {
      document.body.classList.add("overscroll-behavior-none");
    } else {
      document.body.classList.remove("overscroll-behavior-none");
    }
  }, [location.pathname]);
  //
  /**
   * 添加数据统计
   * @see https://developer.umeng.com/docs/67963/detail/74518
   */
  useEffect(() => {
    if (!window._czc) {
      importScript({
        url: _stat.cnzz,
        id: "cnzz",
      });
    }
    if (window._czc) {
      const key = "prevPath";
      const prevPath = localStorage.getItem(key) || "";
      localStorage.setItem(key, location.pathname);

      const refererUrl = prevPath ? `${window.location.origin}${prevPath}` : "/";
      window._czc.push(["_trackPageview", location.pathname, refererUrl]);
    }
  }, [location]);

  const appStore = useAppStore();

  useEffect(() => {
    if (isSdicHomeApp()) {
      sdicHomeEmit("getUserInfo", {
        onCallback(data: any) {
          if (data) {
            try {
              const info = JSON.parse(data);
              appStore.setUserInfo(info);
            } catch (err) {
              console.error(err);
            }
          }
        },
      });
      sdicHomeEmit("getStatusBarHeight", {
        onCallback(data: string) {
          if (data) {
            try {
              const { height } = JSON.parse(data);
              if (height > 0) {
                appStore.setStatusBarHeight(height);
              }
            } catch (err) {
              console.error(err);
            }
          }
        },
      });
    }
  }, []);

  return (
    <Routes>
      <Route index element={<Navigate to={_route.APP} />} />
      <Route path={_route.HOTEL} element={<Hotel />} />
      <Route path={_route.FILE_REVIEW} element={<FileReview />} />
      <Route path={_route.ABOUT} element={<About />} />
      <Route path={_route.SERVICE} element={<Service />} />
      <Route path={_route.EMPOWER} element={<Empower />} />
      <Route path={_route.EMPOWER_BOOK_HOUSE} element={<EmpowerBookHouse />} />
      <Route path={_route.ACTIVITY} element={<Activity />} />
      <Route path={_route.ACTIVITY_CERTIFICATE} element={<ActivityCertificate />} />
      <Route path={_route.MARKET} element={<Market />} />
      <Route path={_route.PDF} element={<Pdf />} />
      <Route path={_route.LOGIN} element={<Login />} />
      <Route path={_route.ALI_CAPTCHA} element={<AliCaptcha />} />
      <Route path={_route.APP} element={<App />} />
      <Route path={_route.LIVE} element={<Live />} />
      <Route path="/k" element={<App />} />
      <Route path="/k/*" element={<App />} />
      <Route path={_route.DOC} element={<Doc />} />
      <Route path={_route.ARTICLE} element={<Article />} />
      <Route path={_route.ARTICLE_TRANSFER} element={<ArticleTransfer />} />
      <Route path={_route.MESSAGE_TREND} element={<MessageTrend />} />
      <Route path={_route.TREND_DETAIL} element={<TrendDetail />} />
      <Route path={_route.MESSAGE_TREND_AUDIT} element={<MessageTrendAudit />} />
      <Route path={_route.MAIL_BOX} element={<MailBox />} />
      <Route path={`${_route.MESSAGE}/*`} element={<Message />} />
      <Route path={`${_route.TREND_AUDIT}/*`} element={<TrendAudit />} />
      <Route path={`${_route.MENU}/*`} element={<Menu />} />
      <Route path={`${_route.CATERING}/*`} element={<Catering />} />
      <Route path={`${_route.PSYCHOLOGY}/*`} element={<Psychology />} />
      <Route path={_route.BADGE} element={<Badge />} />
      <Route path={_route.FLOW} element={<Flow />} />
      <Route path={`${_route.POINTS}/*`} element={<Points />} />
      <Route path={`${_route.WALK}/*`} element={<Walking />} />
      <Route path={`${_route.WISH}/*`} element={<Wish />} />
      <Route path={`${_route.CREATIVE_CENTER}/*`} element={<CreativeCenter />} />
      <Route path={_route.HARDSHIP_AID} element={<HardshipAid />} />
      <Route path={_route.RECREAT_ACTIVITY} element={<RecreatActivity />} />
      <Route path={`${_route.ASSOCIATION}/*`} element={<Association />} />
      <Route
        path={_route.POSTBOX}
        element={
          <AuthRoute>
            <Postbox />
          </AuthRoute>
        }
      />
      <Route path={`${_route.CARE}/*`} element={<Care />} />
      <Route path={`${_route.NEWS}/*`} element={<News />} />
      <Route path={`${_route.MINE}/*`} element={<Mine />} />
      <Route path={`${_route.MEMORY}/*`} element={<Memory />} />
      <Route path={`${_route.LUCKY_WHEEL}/*`} element={<LuckyWheel />} />
      <Route path={`${_route.ADDRESS}/*`} element={<Address />} />
      <Route path={`${_route.VOTE}/*`} element={<Vote />} />
      <Route path={`${_route.CHANG_AN}/*`} element={<ChangAn />} />
      <Route path={_route.SUPPLIER_COLLECTION} element={<SupplierCollection />} />
      <Route path={_route.JD_INTERNAL_REDIRECT} element={<JdInternalRedirect />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
